export default __webpack_public_path__ + "static/RootSans-9Bold-1f9b993dfb033350ac6c93d39cd5e8c7.woff2";